import './ROIButton.css';

export default function ROIButton(props) {

  return (
    <div className='roibutton'>
        <h3>{props.name}</h3>
    </div>
  );
}
